export default __webpack_public_path__ + "static/media/S22MY2E5A.9199f490.jpg";